import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  Typography,
} from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { useApiData } from '../../hooks/useApiData';
import { useUser } from '../../hooks/useUser';
import { paths } from '../../utils/paths';

const isForbidden = (err: Error | null) =>
  (err as any)?.response?.status === 403;

const TimecardCard: React.FC = () => {
  const { user } = useUser();

  const {
    data: timecardUrl,
    error,
    loading,
  } = useApiData<string>((api) => api.attendance.getTimecardRedirect());

  if (!user?.is_swipeclock_enabled) {
    return null;
  }

  if (!loading && isForbidden(error)) {
    return null;
  }

  if (!loading && (error || !timecardUrl)) {
    return (
      <Alert severity="error">
        An error occured while loading the timecard. Please refresh and try
        again
      </Alert>
    );
  }

  return (
    <Card
      sx={{
        borderRadius: 3,
        p: 3,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          mb: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h5">Timecard</Typography>
        <Button
          variant="contained"
          size="small"
          component={RouterLink}
          to={paths.swipeclockTimeCard}
        >
          View timecard
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            borderRadius: 2,
            overflow: 'hidden',
            border: '1px solid #f1f3f4',
          }}
        >
          <iframe
            src={timecardUrl!}
            title="SwipeClock Timecard"
            style={{
              width: '100%',
              height: 630,
              border: 'none',
              display: 'block',
            }}
          />
        </Box>
      )}
    </Card>
  );
};

export default TimecardCard;
